import { Dialog } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import LoadingPlaceholder from "../../../../../components/common/LoadingPlaceholder/LoadingPlaceholder";
import styles from "./LearningHubPopup.module.scss";

export type EmbedItem = {
	embedId: string;
	elementId: string;
};

interface IProps {
	open: boolean;
	onClose: () => void;
	embed: EmbedItem;
}

const HUBSPOT_SCRIPT_SRC = "https://js.hubspot.com/content-embed/v1.js";
const PORTAL_ID = "25399012";

const LearningHubPopup = ({ open, onClose, embed }: IProps) => {
	const { embedId, elementId } = embed;
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		if (!open) return;

		setIsLoading(true);

		const scriptExists = document.querySelector(`script[src="${HUBSPOT_SCRIPT_SRC}"]`);

		const loadEmbed = () => {
			// @ts-ignore
			window.hbspt?.content?.create?.({
				region: "eu1",
				portalId: PORTAL_ID,
				embedId,
				elementId,
			});
		};

		// Start polling to detect when embed content is rendered
		const checkInterval = setInterval(() => {
			const el = document.getElementById(elementId);
			if (el && el.innerHTML.trim().length > 0) {
				setIsLoading(false);
				clearInterval(checkInterval);
			}
		}, 300);

		if (!scriptExists) {
			const script = document.createElement("script");
			script.src = HUBSPOT_SCRIPT_SRC;
			script.async = true;
			script.onload = loadEmbed;
			document.body.appendChild(script);
		} else {
			loadEmbed();
		}

		return () => {
			clearInterval(checkInterval);
		};
	}, [open, embedId, elementId]);

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth={false} classes={{ paper: styles.paper }}>
			<LoadingPlaceholder className={styles.loader} isLoading={isLoading} alwaysRenderChildren>
				<div id={elementId} />
			</LoadingPlaceholder>
		</Dialog>
	);
};

export default observer(LearningHubPopup);
